module.exports = __webpack_public_path__ + "static/media/mew-MAINNET.094f43fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/ethereum/mew-MAINNET.png
// module id = 1857
// module chunks = 157